'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _alias = require('./alias');

var _alias2 = _interopRequireDefault(_alias);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Anchor = (0, _alias2.default)('a', 'Anchor'); /**
                                                   * Alias for the a tag.  The Anchor tag defines a hyperlink which is used to
                                                   * link one web page to another.  If using a click event to perform an action,
                                                   * instead of using Anchor try using Button.
                                                   *
                                                   * @module Anchor
                                                   * @func
                                                   * @since 1.0.0
                                                   * @param {Object} props
                                                   */

exports.default = Anchor;